module.exports = {
    "00001": "Length",
    "00002": "Min. length",
    "00003": "Max. length",
    "00004": "Opening angle",
    "00005": "Area",
    "00006": "Min. weight",
    "00007": "Weight",
    "00008": "Volume",
    "00009": "Inside diameter",
    "00010": "Burning time",
    "00011": "Max. load/shelf",
    "00012": "Max. load",
    "00013": "Quilt cover length",
    "00014": "Quilt cover width",
    "00015": "Pillowcase width",
    "00016": "Pillowcase length",
    "00018": "Coverage:",
    "00020": "Pattern repeat",
    "00021": "Roll length",
    "00022": "Roll width",
    "00023": "Hole diameter",
    "00024": "Height of combination",
    "00025": "Power",
    "00026": "Cord length",
    "00027": "Shade diameter",
    "00028": "Base diameter",
    "00029": "Bed length",
    "00030": "Bed width",
    "00031": "Hole spacing",
    "00032": "Drilled hole diameter",
    "00033": "Picture, height",
    "00034": "Picture, width",
    "00035": "Thickness",
    "00036": "Seat depth",
    "00037": "Seat width",
    "00038": "Max. seat height",
    "00039": "Seat height",
    "00040": "Min. height",
    "00041": "Height",
    "00042": "Diameter",
    "00043": "Min. depth",
    "00044": "Depth",
    "00045": "Min. width",
    "00046": "Max. width",
    "00047": "Width",
    "00048": "Seat diameter",
    "00061": "Package quantity",
    "00081": "Max. depth",
    "00082": "Max. height",
    "00083": "Min. seat height",
    "00084": "Min. seat depth",
    "00085": "Max. seat depth",
    "00086": "Max. weight",
    "00087": "Filling weight",
    "00091": "Total weight",
    "00092": "Filling weight 1",
    "00093": "Filling weight 2",
    "00094": "Total weight 1",
    "00095": "Total weight 2",
    "00096": "Pillow length",
    "00097": "Pillow width",
    "00098": "Max. load/castor",
    "00099": "Building height",
    "00100": "Surface density",
    "00102": "Max. load/leg",
    "00104": "Mattress width",
    "00105": "Mattress length",
    "00108": "Total height",
    "00109": "Footboard height",
    "00110": "Headboard height",
    "00111": "Plank thickness",
    "00113": "Fabric length",
    "00116": "Frame, width",
    "00117": "Frame, depth",
    "00118": "Frame, height",
    "00119": "Number of seats",
    "00121": "Max. power",
    "00122": "Built-in depth",
    "00123": "Built-in width",
    "00124": "Max. load/drawer",
    "00125": "Net weight",
    "00126": "Table width",
    "00127": "Table height",
    "00128": "Table length",
    "00129": "Max. volume",
    "00130": "Min. volume",
    "00131": "Width 1",
    "00132": "Width 2",
    "00133": "Length 1",
    "00134": "Length 2",
    "00135": "Wire length",
    "00136": "Rope length",
    "00137": "Back height",
    "00138": "Armrest height",
    "00139": "Max. neck width",
    "00140": "Min. neck width",
    "00141": "Max. load/hook",
    "00142": "Sprung mattress thickness",
    "00143": "Mattress pad thickness",
    "00145": "Pillow sham length",
    "00146": "Pillow sham width",
    "00147": "Voltage",
    "00148": "Base width",
    "00149": "Min. pole diameter",
    "00150": "Max. pole diameter",
    "00151": "Pole diameter",
    "00152": "Quilt width",
    "00153": "Quilt length",
    "00154": "Base height",
    "00155": "Shade height",
    "00156": "Wall fitting diameter",
    "00157": "Passepartout inside meas. W",
    "00158": "Passepartout inside meas. H",
    "00159": "Total length",
    "00160": "Distance from floor to bed base",
    "00161": "Add-on corner unit, width",
    "00162": "Add-on corner unit+frame, width",
    "00163": "Max. load/glass shelf",
    "00164": "Base length",
    "00165": "Length of chain",
    "00166": "Inside leg of trousers:",
    "00167": "Length of top:",
    "00168": "Mattress thickness",
    "00169": "Tablecloth width",
    "00170": "Tablecloth length",
    "00171": "Napkin length",
    "00172": "Napkin width",
    "00173": "Max. pile length",
    "00174": "Pile thickness",
    "00175": "Pile coverage",
    "00176": "Knots/m",
    "00177": "Width right",
    "00178": "Width left",
    "00179": "Sheet length",
    "00180": "Sheet width",
    "00181": "Total depth",
    "00182": "Frame, thickness",
    "00183": "Max. width of TV",
    "00184": "Max. diameter",
    "00185": "Min. diameter",
    "00186": "Min. pile length",
    "00187": "Plinth, height",
    "00188": "Outside diameter",
    "00189": "Diameter of plant pot",
    "00190": "Height of plant",
    "00195": "Length of collar",
    "00196": "Length of leash",
    "00197": "Width of collar",
    "00198": "Width of leash",
    "00199": "Max. chest measurement",
    "00200": "Min. chest measurement",
    "00201": "Shade width",
    "00202": "Depth of drawer (inside)",
    "00203": "Length of knife blade",
    "00204": "Thickness worktop",
    "00205": "Thickness shelf",
    "00207": "Max. load/holder",
    "00208": "Screen size",
    "00209": "Max. load/open front",
    "00210": "Length of steel",
    "00211": "Babycare mat length",
    "00212": "Babycare mat width",
    "00213": "Lamp head, diameter",
    "00214": "Gooseneck",
    "00215": "Max. area",
    "00216": "Min. area",
    "00217": "Saucer diameter",
    "00218": "Cup height",
    "00219": "Bedspread length",
    "00220": "Bedspread width",
    "00221": "Cushion cover length",
    "00222": "Cushion cover width",
    "00223": "Width, open",
    "00224": "Length, open",
    "00225": "Saucer length",
    "00226": "Saucer width",
    "00227": "Dustbag capacity",
    "00228": "Max. diameter flowerpot",
    "00229": "Length of plant pot",
    "00230": "Width of plant pot",
    "00231": "Min. screen size",
    "00232": "Max. screen size",
    "00233": "Width of chimney",
    "00234": "Depth of chimney",
    "00235": "Depth of wash-basin",
    "00236": "Max. load/armchair frame",
    "00237": "Max. screen size flat screen TV",
    "00238": "Min. screen size flat screen TV",
    "00239": "Distance between spindles",
    "00240": "Distance between shelves",
    "00241": "Distance between beds",
    "00242": "Free height under furniture",
    "00243": "Height of armrest from seat",
    "00244": "Width of drawer (inside)",
    "00245": "Head/footboard height",
    "00246": "Wash-stand width",
    "00247": "Track length",
    "00248": "Filling weight quilt",
    "00249": "Filling weight pillow",
    "00250": "Total weight quilt",
    "00251": "Total weight pillow",
    "00252": "Max. load/rail",
    "00253": "Seat depth, chaise longue",
    "00254": "Seat width, chaise longue",
    "00256": "Depth left",
    "00257": "Depth right",
    "00258": "Max. load/wall cabinet",
    "00259": "Ironing surface, length",
    "00260": "Ironing surface, width",
    "00261": "Max. load TV",
    "00262": "Height ground stick",
    "00263": "Top sheet length",
    "00264": "Top sheet width",
    "00267": "Volume, fridge",
    "00268": "Volume, freezer",
    "00269": "Pile length",
    "00270": "Max. load/compartment",
    "00271": "Slat width",
    "00272": "Extraction rate",
    "00273": "Length between lights",
    "00274": "Cord length from solar panel",
    "00275": "Luminous intensity",
    "00276": "Cord length between lights",
    "00277": "Luminous flux",
    "00283": "Total weight futon",
    "00284": "Filling weight futon",
    "00285": "Futon length",
    "00286": "Futon width",
    "00287": "Tested for",
    "00288": "Pillowcase quantity",
    "00291": "Underframe, length",
    "00292": "Underframe, width",
    "00293": "Volume freezer compartment",
    "00294": "Pages",
    "00295": "System, width",
    "00296": "System, height",
    "00301": "Sound bar height",
    "00302": "Sound bar width",
    "00303": "Sound bar depth",
    "00304": "Subwoofer height",
    "00305": "Subwoofer width",
    "00306": "Subwoofer depth",
    "00307": "Fitted sheet length",
    "00308": "Fitted sheet width",
    "00309": "Inside height",
    "00310": "Inside width",
    "00311": "Inside depth",
    "00312": "System, depth",
    "00313": "Colour Temperature",
    "00314": "Height, door hanger",
    "00315": "Height, wall hanger",
    "00316": "Height including hanger",
    "00317": "Wheel size",
    "00319": "Headboard width",
    "00320": "Depth with suspension rail",
    "00321": "Depth without suspension rail",
    "00322": "Frame width",
    "00325": "Weight, screwdriver",
    "00326": "Weight, screwdriver/drill",
    "00327": "Weight, jigsaw",
    "00328": "Weight, hammer drill",
    "00329": "Cut-out diameter",
    "00330": "Max. load/knob",
    "00331": "Max. load/curtain rod",
    "00332": "Filling weight 3",
    "00333": "Frame size",
    "00334": "Bed runner width",
    "00335": "Bed runner lenght",
    "00337": "Frame height",
    "00338": "Length S/M",
    "00339": "Length L/XL",
    "00340": "Screen height",
    "00344": "Beam angle",
    "00345": "Height with legs",
    "00346": "Height without legs",
    "00347": "Depth with legs",
    "00348": "Depth without legs",
    "00350": "Max. load/small plant pot",
    "00352": "Footstool length",
    "00353": "Footstool width",
    "00356": "Picture without mount, width",
    "00357": "Picture without mount, height",
    "00358": "Picture with mount, width",
    "00359": "Picture with mount, height",
    "00360": "Mount opening, width",
    "00361": "Mount opening, height",
    "00362": "Table top, width",
    "00363": "Table top, length",
    "00364": "Thread count",
    "00365": "Width of roller",
    "00366": "Width of fabric",
    "00368": "Headboard thickness",
    "00369": "Knot Density",
    "00370": "Number of sheets",
    "00371": "Depth chaise longue",
    "00372": "Gravy boat height",
    "00373": "Headboard height without legs",
    "00374": "Number of pages",
    "00377": "Diluted volume",
    "00378": "Max. height, plants",
    "00381": "Weight.",
    "00382": "Chest circumference",
    "00384": "Shelf, depth",
    "00385": "Total width",
    "00386": "Front to back",
    "00387": "Small bowl, volume",
    "00388": "Small bowl, front to back",
    "00389": "Small bowl, width",
    "00390": "Small bowl, depth",
    "00391": "Large bowl, volume",
    "00392": "Large bowl, front to back",
    "00393": "Large bowl, width",
    "00394": "Large bowl, depth",
    "00396": "Inner tent, depth",
    "00397": "Inner tent, width",
    "00398": "Inner tent, height",
    "00399": "Opening angle min.",
    "00400": "Opening angle max.",
    "00402": "Max.",
    "00403": "Cut-out measurement length",
    "00404": "Cut-out measurement width",
    "00405": "Bowl, front to back",
    "00406": "Bowl, width",
    "00407": "Bowl, depth",
    "00408": "Default colour temperature",
    "00409": "Default luminous flux",
    "00410": "Desk height",
    "00411": "Desk width",
    "00412": "Desk length",
    "00413": "Height backrest",
    "00414": "Height including back cushions",
    "00415": "Desktop width",
    "00416": "Desktop depth",
    "00421": "Depth including handle",
    "00424": "Shelf depth",
    "00425": "Shelf width",
    "00426": "Height of legs",
    "00427": "Track width",
    "00428": "Spotlight shade diameter",
    "00429": "Pendant lamp diameter",
    "00430": "Length of hose",
    "00431": "Headshower diameter",
    "00432": "Handshower diameter",
    "00435": "Width cushion 1",
    "00436": "Depth cushion 1",
    "00437": "Height cushion 1",
    "00438": "Width cushion 2",
    "00439": "Depth cushion 2",
    "00440": "Height cushion 2",
    "00445": "Seat width left",
    "00446": "Seat width right",
    "00447": "Min. circumference",
    "00448": "Max. circumference",
    "00449": "Armrest width",
    "00451": "Table max. length",
    "00452": "Table min. length",
    "00453": "Pillowcase length 1",
    "00454": "Pillowcase width 1",
    "00455": "Pillowcase length 2",
    "00456": "Pillowcase width 2",
    "00457": "Total volume",
    "00458": "Max. load/rack",
    "00459": "Min. circumference neck",
    "00460": "Max. circumference neck",
    "00461": "Min. circumference chest",
    "00462": "Max. circumference chest",
    "00465": "Door thickness",
    "00466": "Bowl, volume",
    "00468": "Connection centre distance",
    "00473": "Width 3",
    "00476": "Length 3",
    "00477": "Height 1",
    "00478": "Height 2",
    "00479": "Height 3",
    "00480": "Folded height",
    "00481": "Folded depth",
    "00482": "Max. load/plant pot",
    "00483": "Sleeve length",
    "00485": "Waist",
    "00486": "Length with 1 filler piece",
    "00488": "Width of drawer 1 (inside)",
    "00489": "Width of drawer 2 (inside)",
    "00490": "Depth of drawer 1 (inside)",
    "00492": "Depth of drawer 2 (inside)",
    "00493": "Height of drawer 1 (inside)",
    "00494": "Height of drawer 2 (inside)",
    "00495": "Height of drawer (inside)",
    "00496": "Volume 1",
    "00497": "Volume 2",
    "00498": "Height of drawer 2 (outside)",
    "00499": "Depth of drawer 2 (outide)",
    "00500": "Width of drawer 2 (outside)",
    "00501": "Height of drawer 1 (outside)",
    "00502": "Depth of drawer 1 (outside)",
    "00503": "Width of drawer 1 (outside)",
    "00507": "Max. thickness, mattress",
    "00511": "Circumference",
    "00513": "Width including handle",
    "00514": "Volume",
    "00515": "Height including handle",
    "00518": "Spout, depth",
    "00521": "Length excluding handle",
    "00522": "Max. width, mattress",
    "00523": "Min. width, mattress",
    "00525": "Shelf depth",
    "00527": "Worktop length",
    "00528": "Height, 2 beds",
    "00529": "Total area",
    "00530": "Min. height w charcoal filter",
    "00531": "Max. height w charcoal filter",
    "00534": "Pillow thickness",
    "00535": "Height under loft bed",
    "00540": "Min. height recirculation",
    "00541": "Max. height recirculation",
    "00542": "Min. height extraction",
    "00544": "Max. height extraction",
    "00545": "Bed height",
    "00546": "Ball diameter",
    "00547": "Min. beam angle",
    "00548": "Max. beam angle",
    "00549": "Length to 1st light",
    "00550": "Height incl. headrest",
    "00553": "Free height under bed",
    "00558": "Thermostatic faucet diameter",
    "00563": "Distance between clothes rails",
    "00568": "Min. width, frame",
    "00569": "Max. width, frame",
    "00570": "Shelf width",
    "00571": "Bottom diameter",
    "00572": "Max. load on top panel",
    "00573": "Thickness, outer edge",
    "00574": "Back width",
    "00576": "Drained weight",
    "00577": "Min. length bar",
    "00578": "Max. length bar",
    "00580": "Total depth folded out",
    "00584": "Thickness, edge",
    "00585": "Thickness, slab",
    "00587": "Faucet diameter",
    "00588": "Max. length, spout",
    "00590": "Volume, flexible zone",
    "00591": "Max. load top basket",
    "00592": "Max. load bottom basket",
    "00593": "Filling weight pillowcase",
    "00594": "Filling weight quilt cover",
    "00595": "Total weight pillowcase",
    "00596": "Total weight quilt cover",
    "00601": "Min. installation dimensions",
    "00602": "Max. installation dimensions",
    "00608": "Length, cut-out",
    "00609": "Depth, cut-out",
    "00610": "Max. weight/sleeping level"
  };